import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a50496c0&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=a50496c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50496c0",
  null
  
)

export default component.exports